export default __webpack_public_path__ + "static/media/section2-bg5.51f726e6.png";